import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar.jsx";
import Nav from "../../master/NavBar.jsx";
import Footer from "../footer";
import { Link } from "react-router-dom";
import { BatchlistBySession } from "../../../api/BatchService.js";
import {
  feesfollowup,
  feesResponseFetch,
  feesResponsePost,
  StudentList,
} from "../../../api/FeesDeposite";
import { getSessions } from "../../../api/SessionsService.js";
import { closeModal, ToastMain, SweetAlertShow } from "../../master/Master.jsx";

import StudentPortal from "../../students/v2/StudentPortal.jsx";
import StudentHeader from "../../students/v2/StudentHeader.jsx";

export default function FeeCollectionFollowup() {
  const hasAccess = usePrivateLink();
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [selectedSession, setSelectedSession] = useState("");
  const [selectedBatch, setSelectedbatch] = useState("");
  const [batch, setBatch] = useState([]);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [students, setStudents] = useState([]);
  const [modeldata, setmodeldata] = useState([]);
  const [studentName, setStudentName] = useState("");
  const [loading, setLoading] = useState(false);
  const [followData, setFollowData] = useState([]);
  const [modalData, setModalData] = useState("");
  const [name, setName] = useState("");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [id, setId] = useState("");
  const [page, setPage] = useState(1);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState(date);
  const [leftAmount, setLeftAmount] = useState("");

  const handleReset = () => {
    setSelectedSession("");
    setSelectedbatch("");
    setStudentName("");
    setStudents([]); // Optional: clear student list
  };

  useEffect(() => {
    const getSession = async () => {
      try {
        const response = await getSessions();
        if (response.data.status) {
          const allSessions = response.data.data;
          setData(allSessions);

          // ✅ Default select session with status === "1"
          const activeSession = allSessions.find((s) => s.status === "1");
          if (activeSession) {
            setSelectedSession(activeSession.id);
            batchlist(activeSession.id); // optional: auto-fetch batches for active session
          }
        } else {
          setError("Failed to fetch session.");
        }
      } catch (err) {
        setError(err.response?.data?.message || "Something went wrong");

        SweetAlertShow(
          "error",
          "Error",
          err.response?.data?.message ?? err?.message
        );
      }
    };

    getSession();
  }, []);

  const batchlist = async (sessionId = "") => {
    try {
      // console.log("Fetching batches with session ID:", sessionId); // ✅ Debugging
      const response = await BatchlistBySession(sessionId);

      if (response.data.status == true) {
        setBatch(response.data.batches || []);
        // console.log("Batch fetched", response.data.batches);
      } else {
        setBatch(response.data || []);
        // console.log("Batch fetched", response.data.batches);
      }
    } catch (err) {
      // Swal.fire("error", error, "error");
      setError(err.response?.data?.message || "Something went wrong");
      SweetAlertShow(
        "error",
        "Error",
        err.response?.data?.message ?? err?.message
      );
    }
  };

  const getStudents = async () => {
    try {
      let addUrl = `&session=${selectedSession}&batch=${selectedBatch}&name=${studentName}&start_date=${StartDate}&end_date=${EndDate}&page=${page}&followup=1`;

      const response = await StudentList(addUrl);

      console.log("param", response?.data?.data?.data);
      if (response.data.status) {
        console.log("Filtter students", response);
        setStudents(response.data.data || []);
        setLeftAmount(response?.data);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");

      SweetAlertShow(
        "error",
        "Error",
        err.response?.data?.message ?? err?.message
      );
    }
  };

  useEffect(() => {
    batchlist();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (studentName.length > 0 || selectedBatch || selectedSession) {
        getStudents();
      }
    }, 500); // Wait 500ms after typing or changing filters

    return () => clearTimeout(delayDebounce);
  }, [studentName, selectedBatch, selectedSession, page, StartDate, EndDate]); // 👈 Add these too!
  // only when name changes

  const [filter, setFilter] = useState("All");

  const handelFolloup = async (e) => {
    e.preventDefault();
    setLoading(true); // ⬅️ Start loader

    try {
      const formData = new FormData(e.target);
      const response = await feesResponsePost(formData);

      if (response?.data?.status) {
        closeModal("feefollowup");
        ToastMain.fire({
          icon: "success",
          title: "Create Successfully!",
        }).then(() => {
          getStudents();
        });

        e.target.reset();
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.erros);
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: "Something Went Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const FetchResponse = async () => {
    let addUrl = `&id=${id}&type=${"fees"}`;
    try {
      const response = await feesResponseFetch(addUrl);

      if (response.data.status) {
        const followups = response.data.data?.data || []; // ✅ correct nested array
        setFollowData(followups);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    }
  };

  useEffect(() => {
    if (id) {
      FetchResponse();
    }
  }, [id, name]);
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                <div className="col-md-2 left-pane">
                  <StudentHeader data={"Student Portal"} />
                </div>
                <div className="col-md-10 right-pane">

                  <div className="card p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h3 className="text-primary fw-bold mb-0 mt-3">
                        {" "}
                        Fee Deposit FollowUp's
                      </h3>
                    </div>

                    <div className="p-4 mt-5">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          setPage(1);
                          getStudents();
                        }}
                      >
                        <div className="row gy-3">
                          {" "}
                          <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={selectedSession}
                              onChange={(e) => {
                                setSelectedSession(e.target.value);
                                batchlist(e.target.value);
                              }}
                            >
                              <option value="">Select Session</option>
                              {data.map((session) => (
                                <option key={session.id} value={session.id}>
                                  {session.session}
                                  {session.status === "1"
                                    ? " (Active)"
                                    : session.status === "2"
                                    ? " (Complete)"
                                    : session.status === "0"
                                    ? " (Upcoming)"
                                    : ""}
                                </option>
                              ))}
                            </select>
                            <label>Filter Session</label>
                          </div>
                          <div className="col-md-3 form-floating form-floating-outline">
                            <input
                              type="date"
                              className="form-control"
                              value={StartDate}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                            <label>Start Date</label>
                          </div>
                          <div className="col-md-3 form-floating form-floating-outline">
                            <input
                              type="date"
                              className="form-control"
                              value={EndDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                            <label>End Date</label>
                          </div>
                          {/* <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={selectedBatch}
                              onChange={(e) => setSelectedbatch(e.target.value)} // sirf setState karo
                            >
                              <option value="">Select Batch</option>
                              {batch.map((b) => (
                                <option key={b.id} value={b.id}>
                                  {b.title}
                                </option>
                              ))}
                            </select>
                            <label>Filter Batch</label>
                          </div> */}
                          <div className="col-md-3 form-floating form-floating-outline">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Name / Mobile / Reg No"
                              value={studentName}
                              onChange={(e) => setStudentName(e.target.value)}
                            />
                            <label>Name / Mobile / Reg</label>
                          </div>
                          <div className="col-md-3 col-sm-5">
                            <button
                              type="submit"
                              className="btn btn-label-primary me-1"
                            >
                              <i className="ri-arrow-right-line ri-20px" />
                            </button>
                            <a href="?" className="btn btn-label-danger me-1">
                              <i className="ri-restart-line ri-20px" />
                            </a>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="card mt-5 p-5">
                    {/* Table Section */}
                    <div className="d-flex justify-content-between">
                      <h6 className="text-black">
                        Total Left Amont: -{" "}
                        <span className="text-primary">
                          {leftAmount?.total_left_sum}
                        </span>
                      </h6>
                      <h6 className="text-black">
                        Total Students: -{" "}
                        <span className="text-primary">{students?.total}</span>
                      </h6>
                    </div>
                    <div className="mb-2">
                      Show{" "}
                      <select>
                        <option>50</option>
                        <option>100</option>
                        <option>ALL</option>
                      </select>{" "}
                      entries
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead>
                          <tr className="table-primary text-white bg-primary">
                            <th>#</th>
                            <th>Session</th>
                            <th>Student Name</th>
                            <th>Mobile</th>
                            <th>Course & Batch</th>

                            <th>Left Amount</th>
                            <th>Next Payment Date</th>
                            <th>Next Followup Date</th>

                            <th> Action</th>
                            {/* <th> Action</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {students?.data?.length > 0 ? (
                            students?.data?.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item?.fee_info?.session_year?.session}</td>
                                <td>
                                  {item.name}:({item?.registration_no})
                                </td>
                                <td>{item.phone}</td>
                                <td>
                                  {item?.fee_info?.course?.title}{" "}
                                  <span className="text-primary fw-sembold">
                                    ({item?.fee_info?.batch?.title})
                                  </span>
                                </td>

                                <td className="text-danger fw-bold">
                                  <td>
                                    {(Number(item?.fee_info?.bus_final_fees) ||
                                      0) +
                                      (Number(item?.fee_info?.total_fee) || 0) +
                                      (Number(item?.fee_info?.reg_fee) || 0) -
                                      ((Number(item?.fee_info?.bus_paid_fees) ||
                                        0) +
                                        (Number(item?.fee_info?.fees_paid) ||
                                          0) +
                                        (Number(item?.fee_info?.paid_reg_fee) ||
                                          0)) ===
                                    0 ? (
                                      <span className="badge bg-success">
                                        0
                                      </span>
                                    ) : (
                                      <span className="text-danger fw-bold">
                                        ₹{" "}
                                        {(Number(
                                          item?.fee_info?.bus_final_fees
                                        ) || 0) +
                                          (Number(item?.fee_info?.total_fee) ||
                                            0) +
                                          (Number(item?.fee_info?.reg_fee) ||
                                            0) -
                                          ((Number(
                                            item?.fee_info?.bus_paid_fees
                                          ) || 0) +
                                            (Number(
                                              item?.fee_info?.fees_paid
                                            ) || 0) +
                                            (Number(
                                              item?.fee_info?.paid_reg_fee
                                            ) || 0))}
                                      </span>
                                    )}
                                  </td>
                                </td>
                                <td>
                                  {item?.fee_info?.next_payment_date || "--"}
                                </td>
                                {/* <td>{item?.fee_info?.next_followup_date || "--"}
                                </td> */}
                                <td
                                  style={{
                                    color:
                                      item?.fee_info?.next_followup_date &&
                                      new Date(
                                        item.fee_info.next_followup_date
                                      ).setHours(0, 0, 0, 0) <=
                                        new Date().setHours(0, 0, 0, 0)
                                        ? "red"
                                        : "inherit",
                                  }}
                                >
                                  {item?.fee_info?.next_followup_date
                                    ? new Date(
                                        item.fee_info.next_followup_date
                                      ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                    : ""}
                                </td>
                                <td className="d-flex gap-2 align-items-center">
                                  {/* Fee Deposit Button */}

                                  {/* Fee FollowUp Button (opens modal) */}
                                  {hasAccess('/fees/followup/add') && (
                                    <button
                                      className="btn btn-sm btn-label-danger d-flex align-items-center gap-1"
                                      data-bs-toggle="modal"
                                      data-bs-target="#feefollowup"
                                      onClick={() => {
                                        setmodeldata(item);
                                        setId(item.id);
                                      }}
                                    >
                                      <i className="bi bi-telephone "></i>{" "}
                                      {/* FollowUp */}
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="12"
                                className="text-center text-danger"
                              >
                                Please select a session and batch to view
                                students.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <nav aria-label="Page navigation" className="mt-10">
                        <p>
                          Showing {students?.from} to {students?.to} of{" "}
                          {students?.total} entries
                        </p>
                        <ul className="pagination pagination-sm">
                          {students?.links?.map((btn, i) => (
                            <li
                              className={`page-item  ${
                                btn?.active && "active"
                              }  ${btn?.url ? "" : "disabled"} `}
                            >
                              <button
                                className="page-link waves-effect"
                                onClick={() => {
                                  if (students?.links?.length === i + 1) {
                                    btn?.url &&
                                      setPage(students?.current_page + 1);
                                  } else if (i === 0) {
                                    btn?.url &&
                                      setPage(students?.current_page - 1);
                                  } else {
                                    setPage(btn.label);
                                  }
                                }}
                              >
                                {students?.links?.length == i + 1 ? (
                                  <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                ) : i == 0 ? (
                                  <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                ) : (
                                  btn?.label
                                )}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Code */}

      <div
        className="modal fade"
        id="feefollowup"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <form onSubmit={handelFolloup}>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5">Follow Up Response</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* 🔽 Scrollable Previous Responses Table */}
                <div className="col-xl-12 mb-12 mb-xl-0">
                  <div className="">
                    <h5 className="card-header pb-6">Basic Timeline</h5>
                    <div
                      className="card-body"
                      style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                        border: "1px solid #e0e0e0",
                        borderRadius: "6px",
                        padding: "1rem",
                      }}
                    >
                      <ul className="timeline mb-0">
                        {followData?.length > 0 ? (
                          followData.map((resp, index) => (
                            <li
                              key={resp.id || index}
                              className="timeline-item timeline-item-transparent"
                            >
                              <span className="timeline-point timeline-point-primary"></span>
                              <div className="timeline-event">
                                <div className="timeline-header mb-2">
                                  <h6 className="mb-0">
                                    Follow-up #{index + 1}
                                  </h6>
                                  <small className="text-muted">
                                    {resp.date || "—"}
                                  </small>
                                </div>
                                <p className="mb-2">
                                  <strong>Response:</strong>{" "}
                                  {resp.response || "—"}
                                </p>
                                <p className="mb-0">
                                  <strong>Next Follow-Up:</strong>{" "}
                                  {resp.next_followup_date || "—"}
                                </p>
                              </div>
                            </li>
                          ))
                        ) : (
                          <li className="timeline-item timeline-item-transparent">
                            <span className="timeline-point timeline-point-secondary"></span>
                            <div className="timeline-event">
                              <div className="timeline-header mb-2">
                                <h6 className="mb-0">No follow-ups yet</h6>
                              </div>
                              <p className="mb-0">
                                This student has no recorded responses.
                              </p>
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* 🔽 Hidden Enquiry ID */}
                <input
                  type="hidden"
                  value={modeldata?.fee_info?.id}
                  name="user_id"
                />

                {/* Student Name */}
                <div className="row">
                  <div className="form-floating col-md-4 form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      defaultValue={modeldata?.name}
                      id="studentName"
                      placeholder="Enter Name"
                      readOnly
                    />
                    <label htmlFor="studentName" className="fw-semibold">
                      Name
                    </label>
                    <span className="text-danger">{error?.name ?? ""}</span>
                  </div>
                  <div className="form-floating col-md-4 form-floating-outline mb-4">
                    <select name="type" className="form-control">
                      <option value="fees">Fees</option>
                    </select>
                    <label>Type</label>
                    <span className="text-danger">{error?.type ?? ""}</span>
                  </div>
                  <div className="form-floating col-md-4 form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="amount"
                      id=""
                      placeholder="Amount"
                    />
                    <label htmlFor="studentName" className="fw-semibold">
                      Amount
                    </label>
                    <span className="text-danger">{error?.amount ?? ""}</span>
                  </div>

                  {/* Follow-Up Dates */}
                  <div className="form-floating col-md-6 form-floating-outline mb-4">
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      id="followupDate"
                      defaultValue={new Date().toISOString().split("T")[0]}
                      placeholder="Follow-Up Date"
                      required
                      readOnly
                    />
                    <label htmlFor="followupDate" className="fw-semibold">
                      Follow-Up Date
                    </label>
                    <span className="text-danger">{error?.date ?? ""}</span>
                  </div>
                  <div className="form-floating col-md-6 form-floating-outline mb-4">
                    <input
                      type="date"
                      className="form-control"
                      name="next_followup_date"
                      id="nextFollowupDate"
                      placeholder="Next Follow-Up Date"
                      defaultValue={
                        new Date(Date.now() + 86400000)
                          .toISOString()
                          .split("T")[0]
                      } // 👈 tomorrow's date
                      min={new Date().toISOString().split("T")[0]} // 👈 block past dates
                      required
                    />
                    <label htmlFor="nextFollowupDate" className="fw-semibold">
                      Next Follow-Up Date
                    </label>
                    <span className="text-danger">
                      {error?.next_followup_date ?? ""}
                    </span>
                  </div>

                  {/* Response Textarea */}
                  <div className="form-floating form-floating-outline mb-4">
                    <textarea
                      type="text"
                      className="form-control input-uppercase"
                      name="response"
                      id="remark"
                      style={{ height: "100px" }}
                      placeholder="e.g., Will pay next week, not picking up..."
                      required
                      onChange={(e) => {
                        const value = e.target.value;
                        e.target.value = value
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ");
                      }}
                    ></textarea>
                    <label htmlFor="remark" className="fw-semibold">
                      Response
                    </label>
                    <span className="text-danger">{error?.response ?? ""}</span>
                  </div>
                </div>
              </div>

              {/* 🔽 Footer Buttons */}
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* */}
    </>
  );
}
